module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editDocument":"Edit Document Type"},"al":{"editDocument":"Modifiko Llojin e Dokumentit"}}')
  delete Component.options._Ctor
}
